<app-control-layout [control]="formCtrl" [label]="label" [permission]="permission" [ignoreLabel]="ignoreLabel"
  [labelBlock]="labelBlock" [width]="width" [attr.id]="idName">
 
  <select [formControl]="formCtrl" [attr.id]="idName" class="form-control" [compareWith]="compareFn"
    [style.width]="labelBlock ? 'calc(100% - 140px)' : '100%'"
    [ngClass]="{'border-danger' : control?.errors?.required && (control?.touched || externalTrigger)}" [attr.disabled]="disableSelectBox ? true : null" >
    <ng-container *ngIf="sourceIsLoading; else optionsResolved">
      <option value="null" [disabled]="true">Loading
      </option>
    </ng-container>
    <ng-template #optionsResolved>
      <option *ngIf="defaultOptionMessage" value="null" [disabled]="defaultOptionDisabled">{{defaultOptionMessage}}
      </option>
      <!--if there has been an issue providing options for this select then populate the select with the current value and error notification-->
      <ng-container *ngIf="!source || source.length == 0">
        <option [value]="formCtrl.value" *ngIf="formCtrl?.value">
          {{formCtrl?.value?.name}}
        </option>
        <option disabled>
          {{ 'OPTIONS ERROR' | translate: {value: sourceType} }}
        </option>
      </ng-container>
      <ng-container *ngIf="source && source.length > 0">

        <ng-container *ngIf="optionsType == 'string'; else optionsAreObjects">
          <option #option *ngFor="let optionString of source" [ngValue]="optionString">
            {{optionString}}
          </option>
        </ng-container>
        <ng-template #optionsAreObjects>
          <option #option *ngFor="let entity of source" [ngValue]="entity" [disabled]="entity.disabled">
            <ng-container *ngIf="showOptionCode; else noCode">
              {{entity['code']}} - {{ fieldDescriptionLevelTwo}}
          </ng-container>
            <ng-template #noCode>
              {{fieldDescriptionLevelTwo}}
            </ng-template>
            <ng-container *ngIf="fieldDescriptionLevelTwo; else default">
              {{entity[fieldDescription][fieldDescriptionLevelTwo]}}
            </ng-container>
            <ng-template #default>
              {{fieldDescription !== '-1' ? entity[fieldDescription]: entity}}
            </ng-template>
          </option>
          <option *ngIf="appendOther" [value]="'other'">Other</option>
        </ng-template>       
      </ng-container>
    </ng-template>
  </select>
  
</app-control-layout>
